export default "__VITE_ASSET__35aa73f8__"